<template>
    <list-page-shell title="外勤单">
        <order-workbench
            :extra-query-params="{ is_work_enabled: 1, is_archived: 0 }"
            :show-create-button="false"
            :show-title="false"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'FieldWorkList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/FieldWorkList.vue